module.exports = __webpack_public_path__ + "static/media/review_4.d00ddb28.jpg";